import { render, staticRenderFns } from "./TradeContractFormatGroupForm.vue?vue&type=template&id=1002527a&"
import script from "./TradeContractFormatGroupForm.vue?vue&type=script&lang=ts&"
export * from "./TradeContractFormatGroupForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports